// Import SASS
import '../sass/style.scss'
import '../sass/woocommerce.scss'

// Node_modules
import objectFitImages from 'object-fit-images'
import Animate from 'animate.js';
import AOS from './modules/aos';

import modals from './modules/modals';

import './modules/skip-link-focus-fix'
import './modules/navigation'
import './modules/instagram'
import './modules/aos'
import './modules/stickyvideo'
import './modules/filter'
import { courseSlider, reviewSlider, clientSlider, blogSlider } from './modules/sliders'




const startScripts = () => {
	

	// Object-fit fix
	objectFitImages()

	//courseSlider('.courses-slider')
	reviewSlider('.reviews-slider')
    clientSlider('.clients-slider')
    blogSlider('.blogs__slider')

	
}
startScripts()

// animations
var animate = new Animate({
    offset: [0.1, 0.1],
    delay: 0,
    remove: false,
    reverse: false,
    debug: true,
    onLoad: true,
    onScroll: true
    //disableFilter: isMobile,
});
//animate.init();

AOS.init();


function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

docReady(function() {

    scrollFunction();

    if (document.querySelector(".modal")) { 


    var modal = document.querySelector(".popup");

    // When the window is loaded....
    window.addEventListener("load", function() {

        if(document.cookie.indexOf("visited") >= 0) {
       
          
        } else {

            setTimeout(function(){

              modal.classList.add("fadeInUp");
              modal.classList.add("animated");
              modal.classList.add("active");

              modals.openModal( null, '#popup' );
              
            }, 1000);

        }

    });

}

    if (document.querySelector(".faq__question")) {
        var faqToggle = document.querySelectorAll(".faq__question");
        for (var i = 0; i < faqToggle.length; i++) {
            faqToggle[i].onclick = function () {
                this.nextElementSibling.classList.toggle("active");
                this.querySelector('.arrow').classList.toggle('active');
            };
        }
    }

    if (document.querySelector(".footer__close")) {
        var footerClose = document.querySelector(".footer__close");
        footerClose.onclick = function () {
            document.getElementById("footer__navbar").classList.add("removed");
        };
    }

});


if (document.querySelector('.single-expressions')) {

    const icon1 = document.querySelector('.expression__icon1 svg');
    const icon2 = document.querySelector('.expression__icon2 svg');
    document.addEventListener('scroll', () => {    
        if(icon1) {
            const cords = icon1.getBoundingClientRect();
            const icon1Y = cords.top - 100;

            // console.log(robotY);
         //    const y = window.pageYOffset;
            icon1.style.transform = `rotate(${icon1Y / 20}deg)`;
            icon2.style.transform = `rotate(-${icon1Y / 20}deg)`;
        }
    });

}

// When the user scrolls down 50px from the top of the document, resize the header's font size
window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {

    if (document.getElementById("masthead")) {
        document.getElementById("masthead").classList.add("scrolled");
    }
    if (document.getElementById("footer__navbar")) {
        document.getElementById("footer__navbar").classList.add("scrolled");
    }
    
  } else {
    if (document.getElementById("masthead")) {
        document.getElementById("masthead").classList.remove("scrolled");
    }
    if (document.getElementById("footer__navbar")) {
        document.getElementById("footer__navbar").classList.remove("scrolled");
    }
  }
}








